import { useState, useEffect, useCallback } from "react";
import { api } from "@/lib/api";

/** Case-scoped AI outputs (GET /cases/{id}/ai-outputs), shared across
 * AIPrompts, Reports, and the per-tab AICategoryPanel instances. */
export function useAIOutputs(caseId) {
  const [outputs, setOutputs] = useState([]);

  const refresh = useCallback(() => {
    if (!caseId) return;
    api.get(`/cases/${caseId}/ai-outputs`).then(r => setOutputs(r.data)).catch(() => {});
  }, [caseId]);

  useEffect(() => { refresh(); }, [refresh]);

  const addOutput = useCallback((out) => setOutputs(o => [out, ...o]), []);
  const removeOutput = useCallback((id) => setOutputs(o => o.filter(x => x.id !== id)), []);

  return { outputs, refresh, addOutput, removeOutput };
}
